import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Container,
  TextField,
  Checkbox,
  FormLabel,
  Box,
} from "@mui/material";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import {
  getHarvestEmissions,
  getProcessingEmissions,
  getStorageEmissions,
  getTransferEmissions,
} from "../../globals/emissions";
import { roundDec } from "../../globals/utils";
import { Accordion, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const styles = {
  icon: {
    marginRight: 2,
  },
  mainContent: {
    padding: 0.25,
    paddingLeft: 0.5,
    paddingRight: 0.5,
    flexGrow: 1,
  },
  row: {
    item: true,
    container: true,
    spacing: 1,
    justify: "center",
  },
  fab: {
    position: "fixed",
    bottom: 2,
    left: 2,
  },
  fabRow: {},
  fundSelectorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  buttonRow: {
    margin: "10px",
    display: "flex",
    justifyContent: "space-around",
  },
};

export default function OnePageModel() {
  const classes = styles; // Sty;es

  /* HARVEST */
  //  Crop information
  const [cropType, setCropType] = useState();

  /* HARVEST VARIABLES: These variables are used in the model*/

  //  Pre-harvest information
  const [cropRotation, setCropRotation] = useState();
  const [dripIrrigation, setDripIrrigation] = useState(false);
  const fertilizerTypes = { Organic: "organic", Synthetic: "synthetic" };
  const [fertilizerType, setFertilizerType] = useState();
  const [fertilizer, setFertilizer] = useState();

  //  Post Harvest Information
  const [stubbleBurn, setStubbleBurn] = useState();
  const [weight, setWeight] = useState();
  const [harvestQuality, setHarvestQuality] = useState("");

  //  Final Emissions
  const [electrictyUsed, setElectrictyUsed] = useState();
  const [diselUsed, setDiselUsed] = useState("");
  const [emission, setEmission] = useState();

  /**TRANSPORT */

  const [transportType, setTransportType] = useState("");
  const [distance, setDistance] = useState("");

  /**STORAGE */
  const storageTypes = {
    Traditional: "traditional",
    "Cold Storage": "coldStorage",
  };
  const [storageType, setStorageType] = useState("");
  const [electricity, setElectricity] = useState([]);

  /**Processing */
  const [processingElectricity, setProcessingElectricity] = useState("");

  // Constant update of emissions
  useEffect(() => {
    fertilizerType === "organic" ? setFertilizer(0) : setFertilizer(fertilizer);
    const harvestEmissions = getHarvestEmissions(
      cropType,
      cropRotation,
      dripIrrigation,
      fertilizer,
      stubbleBurn,
      weight,
      electrictyUsed,
      diselUsed,
    )
      ? getHarvestEmissions(
          cropType,
          cropRotation,
          dripIrrigation,
          fertilizer,
          stubbleBurn,
          weight,
          electrictyUsed,
          diselUsed,
        )
      : 0;
    const storageEmissions = getStorageEmissions(storageType, electricity)
      ? getStorageEmissions(storageType, electricity)
      : 0;
    const transportEmissions = getTransferEmissions(transportType, distance)
      ? getTransferEmissions(transportType, distance)
      : 0;
    const processingEmissions = setEmission(
      getProcessingEmissions(processingElectricity),
    )
      ? setEmission(getProcessingEmissions(processingElectricity))
      : 0;
    console.log(getStorageEmissions(storageType, electricity));
    setEmission(
      harvestEmissions +
        storageEmissions +
        transportEmissions +
        processingEmissions,
    );
  });

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div className={classes.mainContent}>
          <Grid
            container
            // spacing={1}
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            {/* HARVEST */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h3">Harvesting</Typography>
              </AccordionSummary>
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h5">Basic Info</Typography>
                </AccordionSummary>

                {/* CROP INFORMATION */}
                {/* cropType */}
                <FormControl fullWidth sx={{ marginTop: 2 }}>
                  <InputLabel id="token-select-label">Crop Type</InputLabel>
                  <Select
                    labelId="select-person-type-label"
                    id="select-crop-type"
                    value={cropType}
                    label="Document Type"
                    onChange={(e) => {
                      setCropType(e.target.value);
                    }}
                  >
                    <MenuItem value={"potato"}>Potato</MenuItem>
                  </Select>
                </FormControl>
              </Accordion>

              {/* PRE-HARVEST */}
              {/* soilQuality */}
              {/* cropRotation */}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h5">Pre-Harvest Info</Typography>
                </AccordionSummary>
                <Box
                  sx={{
                    border: 1,
                    borderColor: "grey.400",
                    borderRadius: "5px",
                    height: "60px",
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FormLabel margin="normal" required>
                    <Checkbox
                      checked={cropRotation}
                      onClick={() => setCropRotation(!dripIrrigation)}
                    />
                    Crop Rotation
                  </FormLabel>
                </Box>
                {/* dripIrrigation */}
                <Box
                  sx={{
                    border: 1,
                    borderColor: "grey.400",
                    borderRadius: "5px",
                    height: "60px",
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FormLabel margin="normal" required>
                    <Checkbox
                      checked={dripIrrigation}
                      onClick={() => setDripIrrigation(!dripIrrigation)}
                    />
                    Drip Irrigation
                  </FormLabel>
                </Box>

                {/* Fertilizer */}
                <FormControl fullWidth sx={{ marginTop: 2 }}>
                  <InputLabel id="fertilizer-type-select-label">
                    Fertilizer Type
                  </InputLabel>
                  <Select
                    labelId="fertilizer-type-select-label"
                    id="fertilizer-type-select"
                    value={fertilizerType}
                    label="Fertilizer Type"
                    onChange={(e) => {
                      setFertilizerType(e.target.value);
                    }}
                  >
                    {Object.keys(fertilizerTypes).map((type_key) => (
                      <MenuItem
                        key={type_key}
                        value={fertilizerTypes[type_key]}
                      >
                        {type_key}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {fertilizerType === "synthetic" ? (
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="txtamount"
                    label="Fertilizer Breakdown (N:P:K)"
                    type="number"
                    id="txtamount"
                    value={fertilizer}
                    onChange={(event) => {
                      setFertilizer(event.target.value);
                    }}
                  />
                ) : null}
              </Accordion>

              {/* POST HARVEST INFO */}

              {/* stubbleBurn */}
              <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="h5">Post-Harvest Info</Typography>
                </AccordionSummary>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="txtamount"
                  label="Stubble Burn (kg)"
                  type="number"
                  id="txtamount"
                  value={stubbleBurn}
                  onChange={(event) => {
                    setStubbleBurn(roundDec(parseFloat(event.target.value)));
                  }}
                />
                {/* weight */}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="txtamount"
                  label="Weight (kg)"
                  type="number"
                  id="txtamount"
                  value={weight}
                  onChange={(event) => {
                    setWeight(roundDec(parseFloat(event.target.value)));
                  }}
                />

                {/* harvestQuality */}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="txtamount"
                  label="Quality Report"
                  type="text"
                  id="txtamount"
                  value={harvestQuality}
                  onChange={(event) => {
                    setHarvestQuality(event.target.value);
                  }}
                />

                {/* electricityUsed */}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="txtamount"
                  label="Electricty Used (kw/Hr)"
                  type="number"
                  id="txtamount"
                  onChange={(event) => setElectrictyUsed(event.target.value)}
                  value={electrictyUsed}
                />

                {/* dieselUsed */}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="txtamount"
                  label="Disel Used (kiloliters)"
                  type="number"
                  id="txtamount"
                  onChange={(event) => setDiselUsed(event.target.value)}
                  value={diselUsed}
                />
              </Accordion>
            </Accordion>

            {/* TRANSPORT */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h3">Transport</Typography>
              </AccordionSummary>
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel id="transport-select-label">
                  Transportation Mode
                </InputLabel>
                <Select
                  margin="normal"
                  labelId="select-transport-type-label"
                  id="select-crop-type"
                  value={transportType}
                  label="Transportation Mode"
                  onChange={(e) => {
                    setTransportType(e.target.value);
                  }}
                >
                  <MenuItem value={"diesel"}>Diesel</MenuItem>
                  <MenuItem value={"electricRenewable"}>
                    Electric Renewable
                  </MenuItem>
                  <MenuItem value={"electricStandard"}>
                    Electric Standard
                  </MenuItem>
                  <MenuItem value={"HFO"}>Ship/HFO</MenuItem>
                </Select>
              </FormControl>

              <TextField
                fullWidth
                margin="normal"
                name="txtamount"
                label="Kilometers"
                type="number"
                id="txtamount"
                value={distance}
                onChange={(event) => {
                  setDistance(event.target.value);
                }}
              />
            </Accordion>

            {/* STORAGE */}
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h3">Storage</Typography>
              </AccordionSummary>
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel id="storage-type-select-label">
                  Storage Type
                </InputLabel>
                <Select
                  labelId="storage-type-select-label"
                  id="storage-type-select"
                  value={storageType}
                  label="Storage Type"
                  onChange={(e) => {
                    setStorageType(e.target.value);
                    if (e.target.value === "traditional") setElectricity(0);
                  }}
                >
                  {Object.keys(storageTypes).map((type_key) => (
                    <MenuItem key={type_key} value={storageTypes[type_key]}>
                      {type_key}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {storageType === "coldStorage" ? (
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="txtamount"
                  label="Electricty Used (kW/hr)"
                  type="number"
                  id="txtamount"
                  value={electricity}
                  onChange={(event) => {
                    setElectricity(event.target.value);
                  }}
                />
              ) : null}
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h3">Processing</Typography>
              </AccordionSummary>

              <TextField
                margin="normal"
                required
                fullWidth
                name="txtamount"
                label="Electricty Used (kW/hr)"
                type="number"
                id="txtamount"
                value={processingElectricity}
                onChange={(event) => {
                  setProcessingElectricity(event.target.value);
                }}
              />
            </Accordion>

            {/* FINAL EMISSIONS */}

            {/* emissions */}
            <TextField
              margin="normal"
              // fullWidth
              // name="txtamount"
              label="CO2 Emission (kgs)"
              value={emission ? emission : null}
              InputLabelProps={{ shrink: true }}
              InputProps={{
                readOnly: true,
                disableUnderline: true,
                style: { pointerEvents: "none" },
              }}
            />
          </Grid>
        </div>
      </Container>
    </>
  );
}
